import React, { Component } from "react";

//component
import CariAppFormViewPg2 from "../presentational/CariAppFormViewPg2";

import { Growl } from 'primereact/growl';

//generic functions
import {
    isEmpty,
    copyArrObject,
    cloneObject
} from "../../../../../functions/generic_functions";

//regex email string
import {
    emailRegex
} from "../../../../../static_data/static_strings";


//router
import {
    withRouter,
} from 'react-router-dom';

//static routes
import {
    cari_api_university_auto_complete_url,
    cari_api_country_auto_complete_url,
    cari_api_load_form_page_2_url,
    cari_home_pg_url,
    cari_api_add_reference_new_institution_url
} from "../../../../../router/static_routes";

//redux
import { connect } from "react-redux";
import {
    setCariFormPageData,
    setCariFormActiveApplicationData,
    openCariModal,
    resetCariActiveData
} from "../../../../../redux/actions/indexActions";

//redux mapper
const mapStateToProps = state => {
    return {
        activeApplicationData: state.cariReducer.activeApplicationData,
        activeVerifiedLoginUserData: state.cariReducer.activeVerifiedLoginUserData
    };
};
const mapDispatchToProps = dispatch => {

    return {
        setCariFormPageData: (page_data) => {
            dispatch(setCariFormPageData(page_data))
        },
        setCariFormActiveApplicationData: (application_data) => {
            dispatch(setCariFormActiveApplicationData(application_data))
        },
        openCariModal: (modal_data) => {
            dispatch(openCariModal(modal_data))
        },
        resetCariActiveData: () => {
            dispatch(resetCariActiveData())
        },
    };
};

class CariAppFormContainerPg2 extends Component {

    state = {
        mounted: false,
        pageLoaded: false,

        submitted: false,
        page_num: 2,
   
        staticUiData: {
            salutationDropdownOptions: [],
        },

        reference_requirements: "",

        postData: [
            // {
            //     hasData: false,
            //     reference_id: null,
            //     email: "",
            //     salutation: "",
            //     first_name: "",
            //     last_name: "",
            //     UniversityName: "",
            //     customInstitutionObj: {
            //         institution_name: "",
            //         institution_country: "",
            //         institution_state: "",
            //         institution_city: "",
            //     },
            //     relationship: "",
            //     customInstitutionCheckboxVal: false,
            //     readOnly: false,
            //     consent: false,
            //     enableConsentCheckbox: false,
            // },

            // {
            //     hasData: false,
            //     reference_id: null,
            //     email: "",
            //     salutation: "",
            //     first_name: "",
            //     last_name: "",
            //     UniversityName: "",
            //     customInstitutionObj: {
            //         institution_name: "",
            //         institution_country: "",
            //         institution_state: "",
            //         institution_city: "",
            //     },
            //     relationship: "",
            //     customInstitutionCheckboxVal: false,
            //     readOnly: false,
            //     consent: false,
            //     enableConsentCheckbox: false,
            // },

            // {
            //     hasData: false,
            //     reference_id: null,
            //     email: "",
            //     salutation: "",
            //     first_name: "",
            //     last_name: "",
            //     UniversityName: "",
            //     customInstitutionObj: {
            //         institution_name: "",
            //         institution_country: "",
            //         institution_state: "",
            //         institution_city: "",
            //     },
            //     relationship: "",
            //     customInstitutionCheckboxVal: false,
            //     readOnly: false,
            //     consent: false,
            //     enableConsentCheckbox: false,
            // },
        ]
    }

    constructor(props) {
        super(props);

        //refs
        this.toastRef = React.createRef();

        //load page data from api
        this.load_page_data_from_api = this.load_page_data_from_api.bind(this);

        //action handlers
        this.handleOnChangeSetParentState = this.handleOnChangeSetParentState.bind(this);

        //handlers for adding new instituion
        this.handleOnChangeAddInstitution = this.handleOnChangeAddInstitution.bind(this);

        //reload page
        this.reloadPageData = this.reloadPageData.bind(this);

        //helper functions
        this.checkIfReferenceDataFilled = this.checkIfReferenceDataFilled.bind(this);
        this.savePostDataToReduxStore = this.savePostDataToReduxStore.bind(this);
        this.getAutoCompleteParams = this.getAutoCompleteParams.bind(this);
        this.checkIfValidEmailRegex = this.checkIfValidEmailRegex.bind(this);
        this.checkIfReferenceHasData = this.checkIfReferenceHasData.bind(this);
    }

    checkIfValidEmailRegex(test_str) {
        var pattern = new RegExp(emailRegex);
        return pattern.test(test_str);
    }

    /*
        post parameters {
            application_id,
            email,
            token, //TODO remove after
        }
        
        return data {
            status => true/false,
            message {
                application_status: "", //values can be: "initial", "completed", or null by default(meaning not created yet)
                postData: [
                    {
                        reference_id: 1,
                        readOnly: false,
                        email: "ben@sfu.ca",
                        salutation: "Mr.",
                        first_name: "Ben",
                        last_name: "someoen".
                        UniversityName: "",
                        customInstitutionObj: {
                            institution_name: "",
                            institution_state: "",
                            institution_city: "",
                            institution_country: ""
                        },
                        relationship: "Supervisor",
                        consent: true,
                    },

                    {
                        reference_id: 2,
                        readOnly: true,
                        email: "ram@sfu.ca",
                        salutation: "Mr.",
                        first_name: "Ram",
                        UniversityName: "",
                        customInstitutionObj: {
                            institution_name: "",
                            institution_state: "",
                            institution_city: "",
                            institution_country: ""
                        },
                        relationship: "co-worker",
                        consent: true,
                    },

                    {
                        reference_id: 3,
                        readOnly: false,
                        email: "stefanie@sfu.ca",
                        salutation: "Ms.",
                        first_name: "Stefanie",
                        UniversityName: "", 
                        customInstitutionObj: {
                            institution_name: "",
                            institution_state: "",
                            institution_city: "",
                            institution_country: ""
                        },
                        relationship: "co-worker",
                        consent: true,
                    },
                ],
                staticUiData: {
                    salutationDropdownOptions: [],
                }
            }
        }
    */
    load_page_data_from_api() {
        //add email and application_id, token to post data
        var currentEmail = this.props.activeVerifiedLoginUserData.email;
        var currentToken = this.props.activeVerifiedLoginUserData.token;
        var currentApplicationId = this.props.activeApplicationData.application_id;
        var post_data = {
            email: currentEmail,
            application_id: currentApplicationId,
            token: currentToken
        };

        var form_data = new FormData();
        form_data.append("email", currentEmail);
        form_data.append("application_id", currentApplicationId);
        form_data.append("token", currentToken);

        // //fetch page data from parameters
        fetch(cari_api_load_form_page_2_url, {
            method: 'POST',
            body: form_data,
            headers: {
                'Accept': 'application/json',
            }
        }).then((response) => {
            //only continue fetch if mounted
            if (this.state.mounted) {
                var responseHttpCode = response.status;
                //good request
                if (responseHttpCode === 200) {
                    return response.json();
                }
                //404 api not found, allows user to retry
                else if (responseHttpCode === 404) {
                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "Bad Request, please try again.",
                    });
                }
                //invalid data and not authorized, reset cari data
                else {
                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "User Session is invalid or has expired, please login again.",
                        callBackFuncOnOk: () => {
                            this.props.resetCariActiveData();
                        }
                    });
                }
            }
        }).then(json => {

                //successfully processed request
                if (!isEmpty(json)
                    && !isEmpty(json.status)
                    && json.status  
                    && !isEmpty(JSON.parse(json.message))
                    && !isEmpty(JSON.parse(json.message).staticUiData)
                ) {
                    var json_data = JSON.parse(json.message);
                    var fetchedPageData = json_data;
                 
                    //set the number of reference requirements
                    this.setState({
                        reference_requirements: json_data['reference_requirements']
                    });

                    for(var i=0; i < this.state.reference_requirements; i++) {
                        this.state.postData.push({
                            hasData: false,
                            reference_id: null,
                            email: "",
                            salutation: "",
                            first_name: "",
                            last_name: "",
                            UniversityName: "",
                            customInstitutionObj: {
                                institution_name: "",
                                institution_country: "",
                                institution_state: "",
                                institution_city: "",
                            },
                            relationship: "",
                            readOnly: false,
                            consent: false,
                            enableConsentCheckbox: false,
                        })
                    }

                    //set the submitted value as true/false if the string value of application status is complete data from fetched page data json
                    var fetchedSubmittedVal = false
                    var fetchedApplicationStatus = null;
                    if (!isEmpty(fetchedPageData.application_status)) {
                        fetchedApplicationStatus = fetchedPageData.application_status;
                        fetchedSubmittedVal = (fetchedPageData.application_status.toLowerCase() === "complete");
                    }

                    //init copy of post data of local state
                    var copyPostData = copyArrObject(this.state.postData);
                    var fetchedPostData = fetchedPageData.postData;

                    //init copy of static UiData of local state
                    var copyStaticUiData = cloneObject(this.state.staticUiData);
                    var fetchedStaticUiData = fetchedPageData.staticUiData;

                    //loop through fetched page data and set the state values if they are not empty
                    for (var i in copyPostData) {
                        //init local variables to detect custom institution 
                        var setCustomInstitutionData = false;
                        var refObj = copyPostData[i];

                        //check if the value at the feteched page data index is not empty
                        if (!isEmpty(fetchedPostData) && !isEmpty(fetchedPostData[i])) {
                            var fetchedRefObj = fetchedPostData[i];

                            //set the json value
                            for (var refKey in refObj) {
                                //if it is the institutionObj, it is another object, loop through and if any data is set, set the custom instutiton data flag variable to true and set the value
                                // if (refKey === "customInstitutionObj") {
                                //     for (var customInstitutionKey in refObj[refKey]) {
                                //         var customInstitutionObj = fetchedRefObj[customInstitutionKey];
                                //         if (!isEmpty(customInstitutionObj)) {
                                //             refObj[refKey][customInstitutionKey] = customInstitutionObj;
                                //             setCustomInstitutionData = true;
                                //         }
                                //     }
                                // }
                                //if value is consent, also set the same value to readOnly
                                if (refKey === "consent") {
                                    refObj[refKey] = fetchedRefObj[refKey];
                                    refObj["readOnly"] = fetchedRefObj[refKey];
                                }
                                //set value normally
                                else {
                                    refObj[refKey] = fetchedRefObj[refKey];
                                }
                            }

                            //check if the key is the customInstitutionObj and its one of its fields is not empty, then set the customInstitutionCheckboxVal to true
                            if (setCustomInstitutionData) {
                                refObj.customInstitutionCheckboxVal = true;
                            }
                        }
                        //if the value is empty, it is the end of the list, exit
                        else {
                            break;
                        }
                    }

                    //get static Ui Data
                    //loop through fetched page data and set the state values if they are not null, empty string or undefined
                    for (var stateKey in copyStaticUiData) {
                        var currFetchedVal = fetchedStaticUiData[stateKey];
                        if (!isEmpty(currFetchedVal)) {
                            copyStaticUiData[stateKey] = currFetchedVal;
                        }
                    }

                    //loop through the current post data and set enableConsentCheckbox based on if all reference data has been filled,
                    for(var referenceIndex in copyPostData) {
                        //if has reference id set has Data to true
                        if (!isEmpty(copyPostData[referenceIndex].reference_id)) {
                            //set has data to true for all reference array if its not empty
                            copyPostData[referenceIndex].hasData = true;
                        }
                        if (this.checkIfReferenceDataFilled(copyPostData[referenceIndex])) {
                            copyPostData[referenceIndex]['enableConsentCheckbox'] = true;
                        }
                        else {
                            copyPostData[referenceIndex]['enableConsentCheckbox'] = false;
                            //also unset the checkbox
                            copyPostData[referenceIndex].consent = false;
                        }
                    }

                    //set page loaded to true
                    this.setState({
                        pageLoaded: true,
                        staticUiData: copyStaticUiData,
                        submitted: fetchedSubmittedVal,
                        postData: copyPostData,
                    }, () => {
                        //get copy of post data and set page num data and save to redux store
                        var reduxCopyPostData = copyArrObject(this.state.postData);
                        this.savePostDataToReduxStore(reduxCopyPostData);

                        //save application status to store
                        var updatedApplicationData = this.props.activeApplicationData;
                        updatedApplicationData.application_status = fetchedApplicationStatus;
                        this.props.setCariFormActiveApplicationData(updatedApplicationData);
                    })
                }
                //if api returns no data, popup modal 
                else {
                    // this.props.openCariModal({
                    //     modalId: "errorModal",
                    //     title: "Failed to retrieve data.",
                    //     callBackFuncOnOk: () => { this.props.history.push(cari_home_pg_url); }
                    // });
                }
            })
            //if api is not found
            .catch((error) => {
                console.log(error);
                this.props.openCariModal({
                    modalId: "errorModal",
                    title: "Something went wrong.",
                    callBackFuncOnOk: () => { this.props.history.push(cari_home_pg_url); }
                });
            });
    }

    checkIfReferenceHasData(currentReferenceData) {
        var hasData = false;
        if (!isEmpty(currentReferenceData)) {
            //check if data is filled
            /*
                saltualtion,
                first_name,
                last_name,
                insitution,
                relationship to applicant,
                email
            */
            if (!isEmpty(currentReferenceData.salutation)
                || !isEmpty(currentReferenceData.first_name)
                || !isEmpty(currentReferenceData.last_name)
                ||
                (!isEmpty(currentReferenceData.UniversityName)
                    || (
                        currentReferenceData.hasOwnProperty('customInstitutionObj') && 
                        currentReferenceData.customInstitutionObj !== undefined && 
                        (
                            !isEmpty(currentReferenceData.customInstitutionObj.institution_name)
                            || !isEmpty(currentReferenceData.customInstitutionObj.institution_country)
                            || !isEmpty(currentReferenceData.customInstitutionObj.institution_state)
                            || !isEmpty(currentReferenceData.customInstitutionObj.institution_city)
                        )
                    )
                )
                || !isEmpty(currentReferenceData.relationship)
                || !isEmpty(currentReferenceData.email)
                || this.checkIfValidEmailRegex(currentReferenceData.email)
            ) {
                hasData = true;
            }
        }
        return hasData;
    }


    savePostDataToReduxStore(reduxCopyPostData) {
        //set page num for redux post data
        reduxCopyPostData['page_num'] = this.state.page_num;
        //remove items not for post data before saving to redux store inside the reference array
        for (var i in reduxCopyPostData) {
            delete reduxCopyPostData[i]["readOnly"];
            delete reduxCopyPostData[i]["customInstitutionCheckboxVal"];
            delete reduxCopyPostData[i]["enableConsentCheckbox"];
        }
        this.props.setCariFormPageData(reduxCopyPostData);
    }

    /*
        returns true/false if reference data has been completely filled for one of them based on passed in currentReferenceData
    */
    checkIfReferenceDataFilled(currentReferenceData) {
        var filled = false;

        if (!isEmpty(currentReferenceData)) {
            //check if all data is filled for a reference
            /*
                saltualtion,
                first_name,
                last_name,
                insitution,
                relationship to applicant,
                email
            */
            if (!isEmpty(currentReferenceData.salutation)
                && !isEmpty(currentReferenceData.first_name)
                && !isEmpty(currentReferenceData.last_name)
                && 
                (!isEmpty(currentReferenceData.UniversityName)
                || (!isEmpty(currentReferenceData.customInstitutionObj)
                    &&
                    !isEmpty(currentReferenceData.customInstitutionObj.institution_name)
                    && !isEmpty(currentReferenceData.customInstitutionObj.institution_country)
                    && !isEmpty(currentReferenceData.customInstitutionObj.institution_state)
                    && !isEmpty(currentReferenceData.customInstitutionObj.institution_city)
                    )
                )
                && !isEmpty(currentReferenceData.relationship)
                && !isEmpty(currentReferenceData.email)
                && this.checkIfValidEmailRegex(currentReferenceData.email)
            ) {
                filled = true;
            }
        }
        return filled;
    }

    componentDidMount() {
        this.setState({
            mounted: true
        }, () => {
            this.load_page_data_from_api();
        })
    }

    componentWillUnmount() {
        this.setState({
            mounted: false
        });
    }

    reloadPageData(fetchedPageData, callBackFunc) {
        //set the submitted value as true/false if the string value of application status is complete data from fetched page data json
        var fetchedSubmittedVal = false
        var fetchedApplicationStatus = null;
        if (!isEmpty(fetchedPageData.application_status)) {
            fetchedApplicationStatus = fetchedPageData.application_status;
            fetchedSubmittedVal = (fetchedPageData.application_status.toLowerCase() === "complete");
        }

        //init copy of post data of local state
        var copyPostData = copyArrObject(this.state.postData);
        var fetchedPostData = fetchedPageData.postData;

        //init copy of static UiData of local state
        var copyStaticUiData = cloneObject(this.state.staticUiData);
        var fetchedStaticUiData = fetchedPageData.staticUiData;

        //loop through fetched page data and set the state values if they are not empty
        for (var i in copyPostData) {
            //init local variables to detect custom institution 
            var setCustomInstitutionData = false;
            var refObj = copyPostData[i];

            //check if the value at the feteched page data index is not empty
            if (!isEmpty(fetchedPostData) && !isEmpty(fetchedPostData[i])) {
                var fetchedRefObj = fetchedPostData[i];

                //set the json value
                for (var refKey in refObj) {
                    //if it is the institutionObj, it is another object, loop through and if any data is set, set the custom instutiton data flag variable to true and set the value
                    // if (refKey === "customInstitutionObj") {
                    //     for (var customInstitutionKey in refObj[refKey]) {
                    //         var customInstitutionObj = fetchedRefObj[customInstitutionKey];
                    //         if (!isEmpty(customInstitutionObj)) {
                    //             refObj[refKey][customInstitutionKey] = customInstitutionObj;
                    //             setCustomInstitutionData = true;
                    //         }
                    //     }
                    // }

                    //if value is consent, also set the same value to readOnly
                    if (refKey === "consent") {
                        refObj[refKey] = fetchedRefObj[refKey];
                        refObj["readOnly"] = fetchedRefObj[refKey];
                    }
                    //set value normally
                    else {
                        refObj[refKey] = fetchedRefObj[refKey];
                    }
                }

                //check if the key is the customInstitutionObj and its one of its fields is not empty, then set the customInstitutionCheckboxVal to true
                if (setCustomInstitutionData) {
                    refObj.customInstitutionCheckboxVal = true;
                }
            }
            //if the value is empty, it is the end of the list, exit
            else {
                 break;
            }
        }

        //get static Ui Data
        //loop through fetched page data and set the state values if they are not null, empty string or undefined
        for (var stateKey in copyStaticUiData) {
            var currFetchedVal = fetchedStaticUiData[stateKey];
            if (!isEmpty(currFetchedVal)) {
                copyStaticUiData[stateKey] = currFetchedVal;
            }
        }

        //loop through the current post data and set enableConsentCheckbox based on if all reference data has been filled,
        for(var referenceIndex in copyPostData) {
            //if has reference id set has Data to true
            if (!isEmpty(copyPostData[referenceIndex].reference_id)) {
                //set has data to true for all reference array if its not empty
                copyPostData[referenceIndex].hasData = true;
            }
            if (this.checkIfReferenceDataFilled(copyPostData[referenceIndex])) {
                copyPostData[referenceIndex]['enableConsentCheckbox'] = true;
            }
            else {
                copyPostData[referenceIndex]['enableConsentCheckbox'] = false;
                //also unset the checkbox
                copyPostData[referenceIndex].consent = false;
            }
        }

        //set page loaded to true
        this.setState({
            pageLoaded: true,
            staticUiData: copyStaticUiData,
            submitted: fetchedSubmittedVal,
            postData: copyPostData,
        }, () => {
            //get copy of post data and set page num data and save to redux store
            var reduxCopyPostData = copyArrObject(this.state.postData);
            this.savePostDataToReduxStore(reduxCopyPostData);

            //save application status to store
            var updatedApplicationData = this.props.activeApplicationData;
            updatedApplicationData.application_status = fetchedApplicationStatus;
            this.props.setCariFormActiveApplicationData(updatedApplicationData);

            //call back function if not null
            if (!isEmpty(callBackFunc)) {
                callBackFunc();
            }
        });
    }


    //handles on change events for setting states for form input for post data
    handleOnChangeSetParentState(value, nameKey) {
        //name key will come in the form of : nameKey?id where Id is the local reference index such as 0,1,2
        //split the string by the "?" character to extract the reference id index number, and name
        var nameKeyArr = nameKey.split("?");
        var refIndex = nameKeyArr[1]; //ref index
        nameKey = nameKeyArr[0]; //nameKey

        //copy of the data to set after
        var copyPostData = copyArrObject(this.state.postData);
        //consent
        if (nameKey === "consent") {
            //if the value is true, send popup modal
            if (value) {
                //popup a modal, ok click, set checkbox, else do nothing
                this.props.openCariModal({
                    modalId: "consentContactReferenceModal",
                    title: "Reference Consent",
                    contentText: "<strong>Please Note:</strong> An automated reference request email will be sent to your reference and you will no longer be able edit this reference's information once you click 'Yes' below.<br/><br/>Do you consent to Simon Fraser University sending a reference request to your specified reference?",
                    callBackFuncOnOk: () => {
                        
                        copyPostData[refIndex].consent = true;

                        //save hasData
                        copyPostData[refIndex].hasData = this.checkIfReferenceHasData(copyPostData[refIndex]);

                        //set data
                        this.setState({
                            postData: copyPostData,
                        }, () => {
                            //get copy of post data and save to redux store
                            var reduxCopyPostData = copyArrObject(this.state.postData);
                            this.savePostDataToReduxStore(reduxCopyPostData);
                            return;
                        });
                    }
                });
            }
            //if the value is false, just set consent to false
            else {
                copyPostData[refIndex].consent = false;
            }
        }

        //catch the name keys for non-post data
        //if the nameKey is the customInstitutionCheckboxVal
        // else if (nameKey === "customInstitutionCheckboxVal") {

        //     //set itself
        //     copyPostData[refIndex].customInstitutionCheckboxVal = value;

        //     //if it is checked, clear out the UniversityName data
        //     if (value) {
        //         copyPostData[refIndex].UniversityName = "";
        //     }
        //     //if it is not checked, clear out the custom university data 
        //     else {
        //         copyPostData[refIndex].customInstitutionObj = {
        //             institution_name: "",
        //             institution_country: "",
        //             institution_state: "",
        //             institution_city: "",
        //         };
        //     }
        // }

        //if the namekey is institution_modal, popup the modal
        else if(nameKey === "institution_modal") {
            //popup a modal, ok click, set checkbox, else do nothing
            this.props.openCariModal({
                modalId: "addInstitutionModal",
                title: "Add Institution",
                contentText: "Please complete the following fields to add an institution.",
                callBackFuncOnOk: (data) => {
                    copyPostData[refIndex]['UniversityName'] = data['institution_name'];
                    copyPostData[refIndex].customInstitutionObj['institution_name'] = data['institution_name'];
                    copyPostData[refIndex].customInstitutionObj['institution_country'] = data['institution_country'];
                    copyPostData[refIndex].customInstitutionObj['institution_state'] = data['institution_state'];
                    copyPostData[refIndex].customInstitutionObj['institution_city'] = data['institution_city'];

                    //set data
                    this.setState({
                        postData: copyPostData,
                    }, () => {
                        //get copy of post data and save to redux store
                        var reduxCopyPostData = copyArrObject(this.state.postData);
                        this.savePostDataToReduxStore(reduxCopyPostData);
                        return;
                    });
                }
            });
        }

        //postdata nameKeys set
        else {
            //find the nameKey and set the value there
            for (var key in copyPostData[refIndex]) {
                if (key === nameKey) {
                    copyPostData[refIndex][key] = value;
                    break;
                }
            }
        }

        //check if the reference data has all been filled for this reference index
        // if (this.checkIfReferenceDataFilled(copyPostData[refIndex])) {
        //     //set enableConsentCHeckbox to true
        //     copyPostData[refIndex]['enableConsentCheckbox'] = true;
        // } 
        // else {
        //     copyPostData[refIndex]['enableConsentCheckbox'] = false;
        //     //also unset the checkbox
        //     copyPostData[refIndex].consent = false;
        // }

        //set has data to true if false
        if (!copyPostData[refIndex].hasData) {
            copyPostData[refIndex].hasData = true;
        }

        //save hasData
        copyPostData[refIndex].hasData = this.checkIfReferenceHasData(copyPostData[refIndex]);

        //set data
        this.setState({
            postData: copyPostData,
        });

        //get copy of post data and save to redux store
        var reduxCopyPostData = copyArrObject(copyPostData);
        //get copy of post data and save to redux store
        this.savePostDataToReduxStore(reduxCopyPostData);
    }

    handleOnChangeAddInstitution(newInstitutionData, postData, refIndex, callBackFunc) {
        //add email and application_id, token to post data
        var currentEmail = this.props.activeVerifiedLoginUserData.email;
        var currentToken = this.props.activeVerifiedLoginUserData.token;
        var currentApplicationId = this.props.activeApplicationData.application_id;
        var newInstitutionObj = newInstitutionData;
        var currentPostData = postData;

        var form_data = new FormData();
        form_data.append("email", currentEmail);
        form_data.append("application_id", currentApplicationId);
        form_data.append("token", currentToken);
        form_data.append("postData", JSON.stringify(currentPostData));
        form_data.append("newInstitutionObj", JSON.stringify(newInstitutionObj));

        fetch(cari_api_add_reference_new_institution_url, {
            method: 'POST',
            body: form_data,
            headers: {
                'Accept': 'application/json',
            }
        }).then((response) => {
            var responseHttpCode = response.status;
            //good request
            if (responseHttpCode === 200) {
                return response.json();
            }
            //404 api not found, allows user to retry
            else if (responseHttpCode === 404) {
                this.props.openCariModal({
                    modalId: "errorModal",
                    title: "Bad Request, please try again.",
                });
            }
            //invalid data and not authorized, reset cari data
            else {
                this.props.openCariModal({
                    modalId: "errorModal",
                    title: "User Session is invalid or has expired, please login again.",
                    callBackFuncOnOk: () => {
                        this.props.resetCariActiveData();
                    }
                });
            }
        }).then(json => {
            //successfully processed request
            if (!isEmpty(json)
                && !isEmpty(json.status)
                && json.status 
                && !isEmpty(JSON.parse(json.message))
                && JSON.parse(json.message).institutionAdded
            ) {
                //Set the university name,city into the input.
                var value = newInstitutionData.institution_name + ', ' + newInstitutionData.institution_city;
                var nameKey = 'UniversityName';

                //copy of the data to set after
                var copyPostData = copyArrObject(this.state.postData);

                //find the nameKey and set the value there
                for (var key in copyPostData[refIndex]) {
                    if (key === nameKey) {
                        copyPostData[refIndex][key] = value;
                        break;
                    }
                }

                if (!copyPostData[refIndex].hasData) {
                    copyPostData[refIndex].hasData = true;
                }

                //save hasData
                copyPostData[refIndex].hasData = this.checkIfReferenceHasData(copyPostData[refIndex]);

                //set data
                this.setState({
                    postData: copyPostData,
                });

                //get copy of post data and save to redux store
                var reduxCopyPostData = copyArrObject(copyPostData);
                //get copy of post data and save to redux store
                this.savePostDataToReduxStore(reduxCopyPostData);

                this.toastRef.current.show({ life: 6000, severity: 'success', summary: 'Successfully saved the new institution!', detail: "" });
            }
            //if api returns no data
            else {
                this.toastRef.current.show({ life: 6000, severity: 'danger', summary: 'Failed to save the new institution!', detail: "" });
            }
        })
        //if api is not found
        .catch((error) => {
            this.toastRef.current.show({ life: 6000, severity: 'danger', summary: 'Failed to save the new institution!', detail: "" });
        });

    }


    /*
    returns the email, token and application id from redux store
    */
    getAutoCompleteParams() {
        //add email and application_id, token to post data
        var currentEmail = this.props.activeVerifiedLoginUserData.email;
        var currentToken = this.props.activeVerifiedLoginUserData.token;
        var currentApplicationId = this.props.activeApplicationData.application_id;

        var autoCompleteParams = {
            email: currentEmail,
            token: currentToken,
            application_id: currentApplicationId
        }
        return autoCompleteParams;
    }

    render() {
        const autoCompleteUrls =  {
            "cari_api_university_auto_complete_url": cari_api_university_auto_complete_url,
            "cari_api_country_auto_complete_url": cari_api_country_auto_complete_url
        }
        return (
            <div>
                <Growl
                    ref={this.toastRef}
                    baseZIndex={9000}
                    position={"topright"}
                />
                <CariAppFormViewPg2
                    autoCompleteUrls={autoCompleteUrls}
                    pageLoaded={this.state.pageLoaded}
                    staticUiData={this.state.staticUiData}
                    postData={this.state.postData}
                    onChangeSetParentState={this.handleOnChangeSetParentState}
                    onAddInstitution={this.handleOnChangeAddInstitution}
                    submitted={this.state.submitted}
                    autoCompleteParams={this.getAutoCompleteParams()}
                />
            </div>
        );
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CariAppFormContainerPg2));
